import React from "react";
import { cn } from "@/lib/utils";
import PhoneInputComponent, { PhoneInputProps } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ disabled, inputClass, ...rest }, ref) => {
    return (
      <PhoneInputComponent
        onlyCountries={["us"]}
        country={"us"}
        disableDropdown
        disableCountryCode
        disableCountryGuess
        inputClass={cn(
          "!w-[100%] !h-[40px] !border !border-g-200 !rounded-md",
          disabled ? "opacity-50 cursor-not-allowed" : "",
          inputClass
        )}
        inputProps={{
          ref,
          disabled: disabled,
        }}
        {...rest}
      />
    );
  }
);

PhoneInput.displayName = "PhoneInput";

export default PhoneInput;
